import { CompanyLogo } from '@components/svgs';
import classNames from 'classnames';
import Image from 'next/image';
import Link from 'next/link';
import { Fragment } from 'react';
import { FooterSection } from './components/FooterSection';
import footerContent from './constants/FooterContent';
import footerExternalContent from './constants/FooterExternalContent';
import footerSocialMedia from './constants/FooterSocialMedia';
import styles from './styles.module.scss';

export const Footer = () => (
  <footer className={styles.footerOuterContainer}>
    <div className={styles.footerOuterContainerInner}>
      <section className={styles.footerTopContainer}>
        <CompanyLogo className={styles.logo} role="img" aria-hidden="true" />
        <div className={styles.footerContentContainer}>
          {footerContent.map((props, index) => (
            <FooterSection
              key={props.title}
              {...props}
              isLastItem={footerContent.length - 1 === index}
            />
          ))}
        </div>
      </section>
      <div className={styles.divider} />
      <section className={styles.footerBottomContainer}>
        <div className={styles.footerBottomContainerWrapper}>
          <CompanyLogo className={classNames(styles.logo, styles.modLogoMobile)} />
          <div className={styles.routingLinksContainer}>
            <div className={styles.footerExternalContentContainer}>
              {footerExternalContent.map(({ title, href }, index) => {
                const isLast = index === footerExternalContent.length - 1;

                return (
                  <Fragment key={title}>
                    <Link prefetch={false} href={href}>
                      {title}
                    </Link>
                    {!isLast && <span className={styles.verticalDivider} />}
                  </Fragment>
                );
              })}
            </div>
          </div>
          <div className={styles.externalLinkContainer}>
            <div className={styles.socialMediaIconContainer}>
              <Link
                href="https://apps.apple.com/ca/app/perksbar/id6450736566"
                target="_blank"
                prefetch={false}
              >
                <Image
                  className={styles.appStore}
                  alt="Download On App Store"
                  src={require('@assets/images/appstore.png')}
                />
              </Link>
              <Link
                href="https://play.google.com/store/apps/details?id=com.perksbar.app"
                target="_blank"
                prefetch={false}
              >
                <Image
                  className={styles.playStore}
                  alt="Download On Google Play"
                  src={require('@assets/images/playstore.png')}
                />
              </Link>
            </div>
            <div className={styles.socialMediaIconContainer}>
              {footerSocialMedia.map(({ image, href }) => (
                <Link
                  key={image.src}
                  href={href}
                  target="_blank"
                  prefetch={false}
                  aria-label="LinkedIn Link"
                >
                  <Image
                    className={styles.socialMediaIcon}
                    src={image}
                    alt=""
                    aria-hidden="true"
                  />
                </Link>
              ))}
            </div>
          </div>
        </div>
      </section>
    </div>
  </footer>
);

Footer.displayName = 'Footer';

export default Footer;
